import { render } from "./PreseedingUnits.vue?vue&type=template&id=d461af9e&scoped=true"
import script from "./PreseedingUnits.vue?vue&type=script&lang=js"
export * from "./PreseedingUnits.vue?vue&type=script&lang=js"

import "./PreseedingUnits.vue?vue&type=style&index=0&id=d461af9e&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d461af9e"]])

export default __exports__